<h2 class="popup-heading" mat-dialog-title>{{ data.countries ? 'Edit' : 'Add' }} Country</h2>
<form (ngSubmit)="submitForm($event)" [formGroup]="form">
  <mat-dialog-content class="mat-typography">
    <div class="errors">
      @for (error of errors | keyvalue; track error) {
        <span>{{ error.value }}</span>
      }
    </div>
    <mat-form-field appearance="fill">
      <mat-label>Name</mat-label>
      <input  matInput [formControl]="form.controls.name" required>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Code</mat-label>
      <input  matInput [formControl]="form.controls.code" required>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="cancel-popup" mat-button mat-dialog-close>Cancel</button>
    <button class="popup-save" mat-button type="submit" cdkFocusInitial [disabled]="processing">
      Save
      @if (processing) {
        <mat-icon>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      }
    </button>
  </mat-dialog-actions>
</form>